<template>
  <li v-bind:class="elClass">
    <h6 class="faq__main-title" v-bind:class="statusClass" v-on:click="toggle">
      <svg v-show="icon" class="+mg-left-xs +mg-right-xs icon --med">
        <use
          xmlns:xlink="http://www.w3.org/1999/xlink"
          :xlink:href="icon"
        ></use>
      </svg>
      {{ title }}
      <span v-bind:class="statusClass" class="faq__icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="18px"
          height="18px"
          viewBox="-1 -2 8 8"
          version="1.1"
        >
          <g stroke="none" stroke-width="1" fill="" fill-rule="evenodd">
            <g transform="translate(-134.000000, -43.000000)" fill="">
              <polygon
                points="134.707107 43 134 43.6965437 137.353553 47 140.707107 43.6965437 140 43 137.358734 45.6018093"
              ></polygon>
            </g>
          </g>
        </svg>
      </span>
    </h6>
    <div class="faq__content" v-show="expanded">
      <slot></slot>
    </div>
  </li>
</template>

<script>
import eventHub from 'apps/bankrate-events'

export default {
  props: {
    // The question text
    title: {
      type: String
    },
    // Any additional class passed
    elClass: {
      type: String,
      default: ''
    },
    // icon to display
    icon: {
      default: false
    },
    // Allow this element to be expanded by default
    opened: {
      default: false
    },
    // Allow to keep only one component expanded at the time
    closeOthers: {
      default: true
    }
  },
  data: function() {
    return {
      // Controls if the content is displayed or not
      expanded: false
    }
  },
  created: function() {
    this.expanded = this.opened || false
    eventHub.$on('FAQ::close', this.close)
  },
  computed: {
    // Generate class for expanded/contracted behavior
    statusClass() {
      return this.expanded ? '--expanded' : ''
    }
  },
  methods: {
    // Contract the content
    close() {
      this.expanded = false
    },
    // Change the behavior of the component
    toggle() {
      if (!this.expanded) {
        if (this.closeOthers) {
          eventHub.$emit('FAQ::close')
        }
        this.expanded = true
      } else {
        this.close()
      }
    }
  }
}
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  overflow: hidden;
  transition: max-height 0.5s ease-out;
  height: auto;
  max-height: 1000px;
  transform-origin: top;
}
.expand-leave-active {
  max-height: 0;
}
</style>
